import { PlannerBase }   from "../planner_base";
import watch from "redux-watch";
import isEqual from 'is-equal';
import flatpickr from 'flatpickr';
import moment from 'moment';
const Japanese = require("flatpickr/dist/l10n/ja.js").Japanese;
import {
  PLANNER_SELECT_START_DATE
} from 'apps/events';
import { Global } from './model';
class DateUI extends PlannerBase {
  start: string;
  datePicker:      any; // FlatpickrInstance
  init(){
    super.init();
    this.start = Global.getPlannerData().start;
    this.listenMount([this.onMountDateUI])
  }
  onMountDateUI(){
    this.setDatePicker();
  }
  setDatePicker(){
    let options:Partial<any>          = this.datePickerOptions();
    this.datePicker      = flatpickr(this.dateInput(), options);
  }
  onChange(){
    let value = this.dateInput().value;
    let newDate = moment(value);
    this.dispatchNewDate(newDate);
  }
  datePickerOptions(){
    return {
      mode:   "single",
      wrap: false,
      locale: Japanese
    };
  }
  dateInput(): HTMLInputElement {
    return <HTMLInputElement>this.querySelector('input[data-type="date"]');
  }
  onClickPrevAMonth(){
    let newDate = this.getNewDateFrom(-1, 'month');
    this.dispatchNewDate(newDate);
  }
  onClickPrevTwoWeeks(){
    let newDate = this.getNewDateFrom(-2, 'week');
    this.dispatchNewDate(newDate);
  }
  onClickTwoWeeks(){
    let newDate = this.getNewDateFrom(2, 'week');
    this.dispatchNewDate(newDate);
  }
  onClickNextAMonth(){
    let newDate = this.getNewDateFrom(1, 'month');
    this.dispatchNewDate(newDate);
  }
  dispatchNewDate(to){
    var customEvent = new CustomEvent(PLANNER_SELECT_START_DATE, {detail: to});
    document.dispatchEvent(customEvent);
  }
  onMouseOver(){
  }

  private getNewDateFrom(num: any, unit: string): any{
    let currentStartDate = Global.getPlannerData().start;
    let date = moment(currentStartDate);
    return date.add(num, unit);
  }
}
riot.mixin('orders.planner.date-ui', DateUI as riot.TagMixin)
